import validate from "/opt/buzztimeprobook/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buzztimeprobook/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-optional": () => import("/opt/buzztimeprobook/frontend/middleware/auth-optional.ts"),
  auth: () => import("/opt/buzztimeprobook/frontend/middleware/auth.ts"),
  cash: () => import("/opt/buzztimeprobook/frontend/middleware/cash.ts")
}